import 'css-chunksrc/client/scenes/moveFolder/styles.scss';export default {
  "main": "_main_n5j6n_1",
  "body": "_body_n5j6n_8",
  "buttons": "_buttons_n5j6n_13"
};